module.exports = __webpack_public_path__ + "static/media/OrnetteColeman.4f99a191.jpeg";


//////////////////
// WEBPACK FOOTER
// ./src/App/Center/Block/img/OrnetteColeman.jpeg
// module id = 616
// module chunks = 0